"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKEN = exports.SID = exports.LOGOUT = exports.LOGIN = exports.FORGOTPW_SUCCESS = exports.FORGOTPW_REQUEST = exports.FORGOTPW_FAILURE = void 0;
/* ACTION TYPE CONSTANTS*/

var LOGIN = exports.LOGIN = 'app/auth/login';
var LOGOUT = exports.LOGOUT = 'app/auth/logout';
var TOKEN = exports.TOKEN = 'app/auth/token';
var SID = exports.SID = 'app/auth/sid';
var FORGOTPW_REQUEST = exports.FORGOTPW_REQUEST = 'app/auth/FORGOT_PASSWORD_REQUEST';
var FORGOTPW_SUCCESS = exports.FORGOTPW_SUCCESS = 'app/auth/FORGOT_PASSWORD_SUCCESS';
var FORGOTPW_FAILURE = exports.FORGOTPW_FAILURE = 'app/auth/FORGOT_PASSWORD_FAILURE';